import {useFormik} from 'formik';
import {useState} from 'react';
import {UpdatePartnerDTO, PartnerModel, usePartnerById} from '../../../entities';
import * as Yup from 'yup';
import {AxiosError} from 'axios';

type UseEditPartnerFormProps = {
  partnerId: string;
  partner: PartnerModel | null;
  setOpen: (open: boolean) => void;
};

export const useEditPartnerForm = ({partnerId, partner, setOpen}: UseEditPartnerFormProps) => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {updatePartnerMutation} = usePartnerById(partnerId);

  const onSubmit = async (values: UpdatePartnerDTO) => {
    setErrorMessage(null);
    try {
      const formattedValues: UpdatePartnerDTO = {
        title: values.title,
        description: values.description || null,
        priority: values.priority,
        website: values.website || null,
      };

      await updatePartnerMutation.mutateAsync(formattedValues);
      setOpen(false);
    } catch (error: any) {
      setErrorMessage(error?.response?.data?.detail || 'Произошла ошибка при обновлении партнера');
    }
  };

  const formik = useFormik({
    initialValues: {
      title: partner?.title || '',
      description: partner?.description || '',
      priority: partner?.priority || 1,
      website: partner?.website || '',
    },
    enableReinitialize: true,
    validationSchema: Yup.object({
      title: Yup.string().max(256, 'Название не должно превышать 256 символов').required('Название обязательно'),
      description: Yup.string().max(1000, 'Описание не должно превышать 1000 символов').nullable(),
      priority: Yup.number().min(1, 'Приоритет должен быть минимум 1').required('Приоритет обязателен'),
      website: Yup.string().url('Введите корректный URL').nullable(),
    }),
    onSubmit,
  });

  return {
    ...formik,
    isLoading: updatePartnerMutation.isPending,
    submitError: updatePartnerMutation.error
      ? (updatePartnerMutation.error as AxiosError<ApiError>).response?.data
      : undefined,
    errorMessage,
    submitForm: () => formik.handleSubmit(),
  };
};
